import { render, staticRenderFns } from "./loginRegister.vue?vue&type=template&id=5ed7f1fd&scoped=true"
import script from "./loginRegister.vue?vue&type=script&lang=js"
export * from "./loginRegister.vue?vue&type=script&lang=js"
import style0 from "./loginRegister.vue?vue&type=style&index=0&id=5ed7f1fd&prod&scoped=true&lang=css"
import style1 from "./loginRegister.vue?vue&type=style&index=1&id=5ed7f1fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed7f1fd",
  null
  
)

export default component.exports